import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-dot-1",
  "use": "icon-ib-dot-1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-dot-1\">\r\n    <path d=\"M511.88622221 2.27555555C793.37244446 2.27555555 1021.72444445 230.62755554 1021.72444445 512.11377779 1021.72444445 793.60000002 793.37244446 1021.72444445 511.88622221 1021.72444445 230.39999998 1021.72444445 2.27555555 793.60000002 2.27555555 512.11377779 2.27555555 230.62755554 230.39999998 2.27555555 511.88622221 2.27555555z\" p-id=\"25418\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol